import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';

function QRRedirect() {
  const { codigo } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const resolveQR = async () => {
      try {
        const res = await api.get(`/public/qr/${codigo}`);
        const unidade = res.data.unidade_id;

        // Redireciona para home com unidade pré-selecionada
        navigate('/', { state: { unidadePre: unidade } });
      } catch (err) {
        setError('QR Code inválido ou expirado');
        console.error(err);
        setTimeout(() => navigate('/'), 3000);
      } finally {
        setLoading(false);
      }
    };

    resolveQR();
  }, [codigo, navigate]);

  return (
    <div className="container loading-container">
      {loading && <p>Processando QR Code...</p>}
      {error && <p className="error-message">{error}</p>}
    </div>
  );
}

export default QRRedirect;
